import { makeVar } from '@apollo/client'

export const currentPageTitleVar = makeVar('')
export const pathwayLayoutVar = makeVar({
  activityFeedWidth: 0.25,
})
